import { Avatar, Badge, Button, DropdownTrigger } from '@heroui/react';
import { useNotificationsData } from '@/features/notifications/hooks/useNotificationsData.hook';

interface Props {
  name: string;
}

const getInitials = (fullName: string): string => {
  const names = fullName.trim().split(' ');

  if (names.length === 0) return '';
  if (names.length === 1) return names[0].charAt(0).toUpperCase();

  const firstInitial = names[0].charAt(0).toUpperCase();
  const secondInitial = names[1].charAt(0).toUpperCase();

  return `${firstInitial}${secondInitial}`;
};

const NavbarButtonImgProfile = ({ name }: Props) => {
  const initials = getInitials(name);
  const { hasNotifications, totalNotifications } = useNotificationsData();

  // Formatear contador para mostrar
  const displayCount =
    totalNotifications > 99 ? '99+' : totalNotifications.toString();

  return (
    <DropdownTrigger>
      <Button
        isIconOnly
        className="rounded-full bg-transparent box-content p-1 overflow-visible"
      >
        <Badge
          content={displayCount}
          color="danger"
          size="sm"
          isInvisible={!hasNotifications}
          classNames={{
            badge:
              'min-w-[18px] h-[18px] text-[10px] font-bold border-2 border-white',
          }}
        >
          <Avatar
            isBordered
            className="transition-transform"
            color="primary"
            name={initials}
            size="md"
            showFallback
          />
        </Badge>
      </Button>
    </DropdownTrigger>
  );
};

export default NavbarButtonImgProfile;
